export default __webpack_public_path__ + "static/media/asensiot_logo.9bfb6ca9.svg";